import React from "react";
import { useUiPack } from "@/hooks/useUiPack";
import MenuItemMaster from "@/pages/masters/MenuItemMaster";
import SimpleProductsList from "@/pages/simple/SimpleProductsList";

export default function UiPackProductsList() {
  const { isSimple } = useUiPack();
  return isSimple ? <SimpleProductsList /> : <MenuItemMaster />;
}
